import { Resource as e } from "@coveo/platform-client";
// src/resources/ConditionResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/search/admin/pipelines/config";
	}
	getConditionObjects() {
		return this.api.get(this.buildPath(`${t.baseUrl}/objects`, { organizationId: this.api.organizationId }));
	}
};
export { t as ConditionResource };

//# sourceMappingURL=ConditionResource.js.map